import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router-dom'
import ErrorBoundary from '../ErrorBoundary'
import CreatePromotionPane from './create/CreatePromotionPane'
import Promotions from '../../containers/promotions/Promotions'
import RidersPerPromotion from '../../containers/promotions/RidersPerPromotion'
interface IPromotionsPaneProps extends RouteComponentProps {
  currentOrgId: string
}

export default class PromotionsPane extends React.Component<IPromotionsPaneProps> {
  public render() {
    if (this.props.currentOrgId) {
      return (
        <ErrorBoundary>
          <Switch>
            <Route path={`${this.props.match.path}/riders/:promotionId`} component={RidersPerPromotion} />
            <Route path={`${this.props.match.path}`} exact={true} component={Promotions} />
            <Route path={`${this.props.match.path}/create`} exact={true} component={CreatePromotionPane} />
          </Switch>
        </ErrorBoundary>
      )
    }
    return <React.Fragment />
  }
}



// WEBPACK FOOTER //
// ./src/components/promotions/PromotionsPane.tsx